export {default} from 'views/StatementSummaryReport/StatementSummaryReport'


// WEBPACK FOOTER //
// ./src/views/Reports/StatementSummaryReport.jsx